import {
  Permissions,
  usePermissionsService,
} from '@cliengo/mfe-utils/services';
import { NavLink } from 'react-router-dom';

import { useNavigationContext } from '../Navigation';

import { Flex } from '@/components/utils';
import { StyledTooltip } from '@/ui/Tooltip/Tooltip';

type NavItemProps = {
  to: string;
  icon: React.ReactNode;
  label: string;
  withPermissions?: Permissions[];
  onClick?: () => void;
  target?: string;
};

export const NavItem = ({
  to,
  icon,
  label,
  withPermissions,
  onClick,
  target,
}: NavItemProps) => {
  const { isSmall } = useNavigationContext();
  const permissionService = usePermissionsService();

  const hasPermission = withPermissions
    ? permissionService.hasOneOf(withPermissions)
    : true;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const content = (
    <Flex
      column={!isSmall}
      className="nav-item"
      sx={{
        gap: isSmall ? '4px' : 0,
        width: isSmall ? '50vw' : '50px',
        height: isSmall ? 'auto' : '50px',
        padding: isSmall ? '16px 8px' : 0,
      }}
    >
      {icon}
      {isSmall && (
        <span
          style={{
            fontSize: '14px',
            textAlign: 'center',
            marginLeft: '12px',
          }}
        >
          {label}
        </span>
      )}
    </Flex>
  );

  if (!hasPermission) {
    return null;
  }

  return isSmall || !label ? (
    <NavLink
      className="navbar-link"
      to={to}
      onClick={handleClick}
      target={target}
      style={{
        textDecoration: 'none',
        color: '#21005D',
      }}
    >
      {content}
    </NavLink>
  ) : (
    <StyledTooltip title={label} placement="right">
      <NavLink
        className="navbar-link"
        to={to}
        onClick={handleClick}
        target={target}
      >
        {content}
      </NavLink>
    </StyledTooltip>
  );
};
